import {Button, Row, Typography} from "antd";
import TableCustom from "components/common/TableCustom/TableCustom";
import React, {useEffect, useRef, useState} from "react";
import {columns} from "./config";
import {shoppingService} from "api";
import {isValuable, randomId} from "helper/common";
import {useAppSelector} from "redux/hooks";
import {tabKeys} from "types/enums";
import {ListActionButton, ModalCustom, Notification} from "components/common";
import Modal from "./Modal/Modal";
const Supplier = () => {
  const [data, setData] = useState<Array<any>>([{}]);
  const [params, setParams] = useState<any>({page: 1, limit: 10});
  const tableRef = useRef<any>(null);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [record, setRecord] = useState<any>();
  const modalRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const listActionButton = (value, record, index) => {
    return (
      <ListActionButton
        editFunction={() => {
          modalRef?.current?.openModal();
          setRecord(record);
        }}
        deleteFunction={() => {
          deleteRecord(record?.id);
        }}
      ></ListActionButton>
    );
  };
  const getData = async params => {
    try {
      setIsLoading(true);
      const res = await shoppingService.getListSupplier(params);
      setData(res?.data?.map(e => ({...e, key: randomId()})));
      setIsLoading(false);
    } catch (error) {
      setData([]);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_SHOPPING.CATALOG) {
      getData(params);
    }
  }, [activeTab, params]);
  const onChangePagination = (page, limit) => {
    setParams({...params, page: page, limit: limit});
  };
  const setPage = page => {
    tableRef?.current?.setPage(page);
  };
  const recallTable = () => {
    setParams({...params, limit: params?.limit, page: 1});
    setPage(1);
  };
  const deleteRecord = async id => {
    try {
      setIsLoading(true);
      await shoppingService.deleteSupplier(id);
      setIsLoading(false);
      Notification("success", "Đã xóa thành công");
      recallTable();
    } catch (error) {
      setIsLoading(false);
      Notification("error", error?.response?.data ?? "Đã xảy ra lỗi");
    }
  };
  return (
    <div className="container">
      <Row justify={"space-between"} style={{marginBottom: 8}}>
        <div className="title-catalog">
          <Typography.Text strong style={{fontSize: 18}}>
            Danh mục nhà cung cấp
          </Typography.Text>
        </div>
        <Button
          type="primary"
          onClick={() => {
            modalRef?.current?.openModal();
            setRecord(null);
          }}
        >
          Thêm mới
        </Button>
      </Row>

      <TableCustom
        isLoading={isLoading}
        ref={tableRef}
        dataSource={data}
        columns={columns}
        onChangePagination={onChangePagination}
        listActionButton={listActionButton}
      ></TableCustom>
      <ModalCustom
        width={800}
        ref={modalRef}
        title={`${isValuable(record) ? "Sửa thông tin" : "Thêm"} nhà cung cấp`}
      >
        <Modal recallTable={recallTable} record={record}></Modal>
      </ModalCustom>
    </div>
  );
};
export default Supplier;
